import React, {useCallback} from 'react';

import {getOwnerChoices} from 'create-components/OwnableUtil';
import CreateTemplateCollectionModal from 'notebook/entry-templates/collections/CreateTemplateCollectionModal';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import runModal from 'ui-library/runModal';

interface NewTemplateCollectionButtonProps {
  compact: boolean;
}

const DISABLED_TOOLTIP_TEXT = 'Please contact your administrator to create a template collection';
const ENABLED_TOOLTIP_TEXT = 'Create template collection';

export default function NewTemplateCollectionButton(props: NewTemplateCollectionButtonProps): JSX.Element {
  const disabled = getOwnerChoices().length === 0;
  const style = props.compact ? ButtonStyle.TERTIARY_BLUE : ButtonStyle.SECONDARY;
  const tooltipText = disabled ? DISABLED_TOOLTIP_TEXT : ENABLED_TOOLTIP_TEXT;
  const handleClick = useCallback(() => {
    runModal(CreateTemplateCollectionModal, {});
  }, []);
  return (
    <Tooltip text={tooltipText}>
      <Button
        icon="compose"
        buttonStyle={style}
        size={ButtonSize.SMALL}
        disabled={disabled}
        onClick={handleClick}
      />
    </Tooltip>
  );
}
